// extracted by mini-css-extract-plugin
export var footerMenu = "FooterMenu-module--footer-menu--8c541";